import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

function getLang() {
    return window.localStorage.getItem("lang") || 'en'
}
const url =  location.origin.indexOf('localhost')>-1 ? '/api' : ''

// const url = '/api'

//登录
const login = (params) => axios.post(`${url}/apicom/user/login`,params)

//钱包登录
const walletLogin = (params) => axios.post(`${url}/apicom/user/walletlogin`,params)
const ptlogin = (params) => axios.get(`${url}/apicom/user/ptlogin`,params)

//忘记密码
const forget = (params) => axios.post(`${url}/apicom/user/forgotpassword`,params)


//安全绑定
const addMobile = (params) => axios.post(`${url}/apicom/member/addmobile`,params)



//首页加密货币列表
const coinList = (params) =>axios.post(`${url}/apicom/transaction/tplist`, params)

//首页外汇列表
const whList = (params) =>axios.post(`${url}/apicom/wporder/hblist `, params)

//股票大盘指数
const stockLarge = (params) =>axios.post(`${url}/market/index/stock_large `, params)

//加密货币轮播图
const getcplider = (params) => axios.post(`${url}/apicom/index/getSlider `,params)

//币种k线图
const coinKLinedata = (params) => axios.post(`${url}/apicom/transaction/getkdata`,params)

//永续合约列表
const getTphendlist = (params) => axios.post(`${url}/apicom/transaction/tphendlist`,params)

//交割合约列表
const getTpmicrolist = (params) => axios.post(`${url}/apicom/transaction/tpmicrolist`,params)

//获取新闻列表
const getNewsLsit = (params) => axios.post(`${url}/apicom/news/getlists`,params)

//获取新闻详情
const getNewsDetail = (params) => axios.post(`${url}/apicom/news/getdata`,params)


//获取信息
const getMessage = (params) => axios.post(`${url}/apicom/member/messlist`,params)


 

//获取用户资金
const getUserMoney = (params) => axios.post(`${url}/apicom/user/usermoney`,params)

//实名认证
const setRealname = (params) => axios.post(`${url}/apicom/profile/realname`,params)

//高级认证
const advancedCtf = (params) => axios.post(`${url}/apicom/profile/realnameto`,params)

//修改登录密码
const changePassword = (params) => axios.post(`${url}/apicom/profile/password`,params)


//修改资金密码
const changeFundsPassword = (params) => axios.post(`${url}/apicom/profile/paypass`,params)

//设置资金密码
const setFundsPassword = (params) => axios.post(`${url}/apicom/profile/paypass`,params)



//帮助中心列表
const getHelpList = (params) => axios.post(`${url}/apicom/user/help`,params)

//帮助中心详情
const getHelpDetail = (params) => axios.post(`${url}/apicom/news/help`,params)

//获取关于我们信息
const getAboutUs = (params) => axios.post(`${url}/apicom/user/about`,params)

//分享二维码接口
const getShareInfo = (params) => axios.post(`${url}/apicom/Invite/conf`,params)

//单个币种详情
const getCoinInfo = (params) => axios.post(`${url}/apicom/transaction/getmousdt`,params)


//获取单个币种的最新交易信息
const getCoinTradeInfo = (params) => axios.post(`${url}/apicom/transaction/getusdtvol`,params)

//在线客服
const getKefuInfo = (params) => axios.post(`${url}/apicom/index/getkefu`,params)

//注册
const register = (params) => axios.post(`${url}/apicom/user/register`,params)

//获取用户信息
const getUserInfo = (params) => axios.post(`${url}/apicom/member/userInfo`,params)


//获取推广记录
const getPromoteInfo = (params) => axios.post(`${url}/apicom/user/myteamnumber`,params)


//查询是否授权
const searchIsAuth = (params) => axios.post(`${url}/apicom/user/auth_login`,params)

//授权后提交
const postAuth = (params) => axios.post(`${url}/apicom/user/auth_register`,params)




//添加自选
const addOptional = (params) => axios.post(`${url}/apicom/member/myoptionaadd`,params)

//删除自选
const delOptional = (params) => axios.post(`${url}/apicom/member/myoptionadel`,params)

//自选列表
const getOptionalList = (params) => axios.post(`${url}/apicom/member/myoptionalist`,params)

//上传图片接口
const uploadImg = (params) => axios.post(`${url}/apicom/profile/upload`,params)

//获取交割时间
const getSeconds = (params) => axios.post(`${url}/apicom/transaction/getseconds`,params)

//获取首页公告
const getNoticeList = (params) => axios.post(`${url}/apicom/news/shouye`,params)

//帮助公告详情
const getNoticeDetail = (params) => axios.post(`${url}/apicom/news/shouyeinfo`,params)

const getMessageDetail = (params) => axios.post(`${url}/apicom/member/messid`,params)


//获取开仓倍数信息
const getleverList = (params) => axios.post(`${url}/apicom/transaction/getlever`,params)

//交割合约记录
const deliveryRecord = (params) => axios.post(`${url}/apicom/mirorder/mymicrlist`,params)

//交割合约详情
const deliveryOrderInfo = (params) => axios.post(`${url}/apicom/mirorder/order`,params)

//交割合约结算
const deliveryOrderClose = (params) => axios.post(`${url}/apicom/mirorder/clostion`,params)


//充值
const doCharge = (params) => axios.post(`${url}/apicom/Recharge/doCharge`,params)

//充值记录
const rechargeLog = (params) => axios.post(`${url}/apicom/user/moneyrecharge`,params)

//提现
const doWithdraw = (params) => axios.post(`${url}/apicom/Withdraw/doWithdraw`,params)

//提现说明手续费
const withdrawInfo = (params) => axios.post(`${url}/apicom/user/userwithdrawmoney`,params)


//提币记录
const withdrawLog = (params) => axios.post(`${url}/apicom/user/moneywithdraw`,params)


//账变记录
const moneyLog = (params) => axios.post(`${url}/apicom/moneylog`,params)


//交割合约下单
const deliverySubmit = (params) => axios.post(`${url}/apicom/transaction/submit`,params)

//基金理财列表
const financialList = (params) => axios.get(`${url}/apicom/mirorder/buelist?token=${params.token}`)

//基金理财质押信息
const financialInfo = (params) => axios.post(`${url}/apicom/mirorder/myzhiyainfo`,params)

//质押单项目详情信息
const financialDetail = (params) => axios.post(`${url}/apicom/mirorder/zhiyalist`,params)

//质押记录
const financialRecord = (params) => axios.post(`${url}/apicom/mirorder/myzhiya`,params)


//质押单项目购买
const financialBuy = (params) => axios.post(`${url}/apicom/mirorder/buy`,params)



//永续合约下单
const contractTrade = (params) => axios.post(`${url}/apicom/transaction/buy`,params)


//永续持仓合约列表
const contractOrderList = (params) => axios.post(`${url}/apicom/mirorder/myorderlist`,params)

//充值地址
const rechargeAddress = (params) => axios.post(`${url}/apicom/user/rechargeadd`,params)

//平仓操作
const closeOrder = (params) => axios.post(`${url}/apicom/mirorder/colseorder`,params)

//委托撤单操作
const cancelOrder = (params) => axios.post(`${url}/apicom/mirorder/cancelorder`,params)

//现货交易买入
const spotBuy = (params) => axios.post(`${url}/apicom/member/buy`,params)

//现货交易卖出
const spotSell = (params) => axios.post(`${url}/apicom/member/sell `,params)
 
//现货交易仓位
const spotOrderList = (params) => axios.post(`${url}/apicom/transaction/myorderlist`,params)

//现货撤单
const spotcancelOrder = (params) => axios.post(`${url}/apicom/transaction/cancelorder`,params)

//永续订单详情
const contractOrderDetail = (params) => axios.post(`${url}/apicom/transaction/order`,params)


//发起闪兑
const coinTransfer = (params) => axios.post(`${url}/apicom/user/transfrom`,params)

//发起划转
const flashexchange = (params) => axios.post(`${url}/apicom/user/flashexchange`,params)

//股票列表
const stockList = (params) => axios.post(`${url}/market/index/stock_top10`,params)

//股票k线
const stockKdata = (params) => axios.post(`${url}/apicom/mirorder/getkdata`, params)

//外汇k线
const whKdata = (params) => axios.post(`${url}/apicom/wporder/getprodata`,params)


const usStock = (params) => axios.post(`https://api.investing.com/api/financialdata/assets/equitiesByCountry/default?fields-list=id%2Cname%2Csymbol%2Chigh%2Clow%2Clast%2ClastPairDecimal%2Cchange%2CchangePercent%2Cvolume%2Ctime%2CisOpen%2Curl%2Cflag%2CcountryNameTranslated%2CexchangeId%2CperformanceDay%2CperformanceWeek%2CperformanceMonth%2CperformanceYtd%2CperformanceYear%2Cperformance3Year%2CtechnicalHour%2CtechnicalDay%2CtechnicalWeek%2CtechnicalMonth%2CavgVolume%2CfundamentalMarketCap%2CfundamentalRevenue%2CfundamentalRatio%2CfundamentalBeta%2CpairType&country-id=5&page=0&page-size=10&limit=0`,params)

//搜索
const stockSearch = (params) => axios.post(`${url}/market/index/stock_search`,params)


//设置止盈止损
const setDoupOrder = (params) => axios.post(`${url}/apicom/mirorder/setdouporder`,params)

//发送手机验证码
const sendSms = (params) => axios.post(`${url}/apicom/profile/sendsms`,params)

//发送邮箱验证码
const sendEmail = (params) => axios.post(`${url}/apicom/profile/sendemailsms`,params)




export {
    login,
    forget,
    addMobile,
    walletLogin,
    getcplider,
    coinList,
    whList,
    stockSearch,
    ptlogin,
    coinKLinedata,
    getTphendlist,
    stockLarge,
    getTpmicrolist,
    getNewsLsit,
    getUserMoney,
    setRealname,
    getNewsDetail,
    getMessage,
    advancedCtf,
    contractOrderDetail,
    setDoupOrder,
    changePassword,
    changeFundsPassword,
    getHelpList,
    getHelpDetail,
    getAboutUs,
    getShareInfo,
    getCoinInfo,
    getKefuInfo,
    register,
    getUserInfo,
    getPromoteInfo,
    getCoinTradeInfo,
    addOptional,
    delOptional,
    getOptionalList,
    uploadImg,
    getSeconds,
    getNoticeList,
    getNoticeDetail,
    searchIsAuth,
    postAuth,
    getleverList,
    getMessageDetail,
    deliveryRecord,
    deliveryOrderInfo,
    deliveryOrderClose,
    doCharge,
    rechargeLog,
    doWithdraw,
    withdrawInfo,
    withdrawLog,
    moneyLog,
    deliverySubmit,
    financialList,
    financialInfo,
    financialBuy,
    financialDetail,
    financialRecord,
    contractTrade,
    contractOrderList,
    rechargeAddress,
    closeOrder,
    cancelOrder,
    spotBuy,
    spotSell,
    spotOrderList,
    spotcancelOrder,
    flashexchange,
    coinTransfer,
    usStock,
    stockList,
    stockKdata,
    whKdata,
    sendSms,
    sendEmail,
    setFundsPassword
   
    
}


// WEBPACK FOOTER //
// ./src/service/getdata.js